import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.video = this.el
    }

    destroy() {
        super.destroy()
    }

    pauseVideo() { 
        if (!this.isPlaying) return
        this.video.pause()
        this.isPlaying = false
    }

    resumeVideo() {
        if (this.isPlaying) return
        this.video.play()
        this.isPlaying = true
    }

    togglePlay() {
        this.isPlaying ? this.pauseVideo() : this.resumeVideo()
    }
}
